// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__2J0sa","formSpace":"styles_formSpace__1H4SJ"};